import React from "react";

import './style.css'
/* eslint import/no-webpack-loader-syntax: off */
import SvgFrame from "-!svg-react-loader!../../../icons/frame.svg";

export default function Index({
                                  position = '',
                                  children,
                                  description = '',
                                  title = '',
                                  rows = []
                              }) {
    return (
        <div className={`content_wrap ${position}`}>
            <div className="img_wrap">
                <SvgFrame/>
                {children}
            </div>
            <div className="text_wrap">
                <h2>{title}</h2>
                <div className="description">
                    {description}
                </div>
                <div className="info_details">
                    {rows.map(item => (
                        <div className="detail_block" key={item.label}>
                            <span className="label">{item.label}</span>
                            <span className="value">{item.value}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/new-components/templates/text-image/index.js